<template>
    <div class="popupComponent" v-if="show" @touchmove.prevent>
        <div class="box" @click.stop="">
            <img class="popupTitle"
            :src="popupType === 'rule' ? ruleTitle : prizeTitle" alt="">
            <div class="content">
                <div class="ruleText" v-if="popupType === 'rule'">
                    <div v-html="atStr(activityRule)"></div>
                    <p class="tips">最终解释权归云图教育/启航教育所有</p>
                </div>
                <div class="prizeBox" v-else-if="popupType === 'prize' && prizeInfo.prizeName">
                    <div class="prizeInfo">
                        <h5>{{prizeInfo.prizeName}}</h5>
                        <p><span>奖品类型：</span>{{prizeInfo.prizeType === 1 ? '实物' : prizeInfo.prizeType === 2 ? '课程' : prizeInfo.prizeType === 3 ? '优惠券' : '现金'   }}</p>
                        <p><span>领取时间：</span>{{prizeInfo.receiveTime}}</p>
                    </div>
                    <div class="prizeAddress" v-if="prizeInfo.province">
                        <h5>发货信息</h5>
                        <p><span>收货姓名：</span>{{prizeInfo.userName}}</p>
                        <p><span>联系电话：</span>{{prizeInfo.phone}}</p>
                        <p><span>邮寄地址：</span>{{prizeInfo.province}} {{prizeInfo.city}} {{prizeInfo.area}} {{prizeInfo.address}}</p>
                    </div>
                </div>
            </div>
            <img class="closePopup" @click="show = false" src="@/assets/img/pullNew/close.png" alt="">
        </div>
    </div>
</template>
<script>
export default {
  data() {
    return {
      show: false,
      ruleTitle: require('@/assets/img/pullNew/rulePopupTitle.png'),
      prizeTitle: require('@/assets/img/pullNew/prizePopupTitle.png'),
    };
  },
  props: {
    popupType: {
      type: String,
      default: 'rule',
    },
    activityRule: {
      type: String,
    },
    prizeInfo: {
      type: Object,
    },
  },
  methods: {
    atStr(str) {
      const datAt = str.replace(/(\r\n)|(\n)/g, '<br>');
      return datAt;
    },
  },
};
</script>
<style scoped lang="scss">
.popupComponent {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    z-index: 10002;
    .box {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        width: 654px;
        min-height: 304px;
        border-radius: 16px;
        padding: 16px;
        background: #FFFBE6;
        box-sizing: border-box;
        .popupTitle {
            position: absolute;
            width: 412px;
            height: 112px;
            left: 50%;
            transform: translateX(-50%);
            top: -34px;
        }
        .content {
            background: #FF1A3F;
            border-radius: 16px;
            padding: 60px 32px 32px;
            box-sizing: border-box;
            min-height: 270px;
            .ruleText {
                div {
                    color: #fff;
                    font-size: 28px;
                }
                .tips {
                    width: 100%;
                    text-align: center;
                    font-size: 24px;
                    color: #F2EEDA;
                    margin-top: 40px;
                }
            }
            .prizeBox {
              div {
                width: 100%;
                background: #fff;
                border-radius: 16px;
                padding: 32px;
                box-sizing: border-box;
                h5 {
                  font-size: 32px;
                  color: #333333;
                  font-weight: 500;
                  margin: 10px 0;
                }
                p {
                  line-height: 50px;
                  font-size: 24px;
                  color: #333333;
                  span {
                    color: #999999;
                  }
                }
              }
              .prizeInfo {
                min-height: 200px;
              }
              .prizeAddress {
                margin-top: 24px;
              }
            }
        }
        .closePopup {
            width: 64px;
            height: 64px;
            position: absolute;
            left: 50%;
            bottom: -120px;
            transform: translateX(-50%);
        }
    }

}
</style>
